import "./BrowserTabAlert.css";

export function BrowserTabAlert() {
	return (
		<div className="browser-tab-alert-container">
			<div className="browser-tab-alert">
				<h2>Outra aba do aplicativo já está aberta!</h2>
				<p>Por favor, feche as outras abas para continuar usando o aplicativo.</p>
				<div>
					<button className="close-tab-button" type="button" onClick={e => window.location.href = "https://bravas.ind.br"}>
						Fechar
					</button>
					<button type="button" className="reload-tab-button" onClick={e => window.location.reload()}>
						Recarregar
					</button>
				</div>
			</div>
		</div>
	);
}